import { Grid } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import {
  GPLUCoverageCode
} from '../../../PlanTemplates/GWL/gpluConstants';
import { getGPLURatingBlockPropertyPaths } from '../PropertyPaths';

export const getParentPath = (planIndex: number = 0, coverageIndex: number = 0) =>
  `benefitPackagingDetail.plans[${planIndex}].coverageDefs[${coverageIndex}]`;

export const GPLUSpouseRatingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getGPLURatingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: { key: 'row-a1cb4d10-8258-44af-9ef0-d4dfea970eee' },
      items: [
        {
          key: '1bb30360-c8ea-40f7-86cd-44baa97d3313',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Rate Format"
              id={propertyPaths.rateFormatCd}
              value={getQuoteFieldValue(propertyPaths.rateFormatCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.rateFormatCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUBenefitCoverageRatingDetails.rateFormatCd"
              coverageCode={GPLUCoverageCode.SPOUSE_WHOLE_LIFE}
              required
              disabled
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Rating" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
